import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid py-5 custom-descripcion-evento" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 offset-md-1 col-md-10 text-center px-4" }
const _hoisted_4 = { class: "fw-bold mb-4 text-uppercase" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", {
  class: "custom-separator",
  style: {"height":"2px","background-color":"black","width":"50%","margin":"2rem auto"}
}, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  href: "/registro",
  class: "btn btn-primary px-4 py-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "QUIERO UNIRME", -1)
const _hoisted_9 = [
  _hoisted_8
]


import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'



export default /*#__PURE__*/_defineComponent({
  __name: 'TheDescripcionEvento',
  props: {
    title: null,
    html: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  html: string
};



const { state } = useStore<VuexStore>(key)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(props.title), 1),
        _hoisted_5,
        _createElementVNode("div", {
          class: "mb-4",
          innerHTML: props.html
        }, null, 8, _hoisted_6),
        (!_unref(state).authUser)
          ? (_openBlock(), _createElementBlock("a", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})